<template>
  <div class="other" :class="$store.state.user.isNested && 'pb300'">
    <!-- header -->
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
      <span>{{ l.other_nav_title }}</span>
      <div class="icon_box"></div>
    </div>
    <!-- 进度条 -->
    <div class="form_body">
      <!-- 进度条 -->
      <div class="stepImg_box">
        <img class="stepImg" src="@/assets/userInfo/tab4.png" alt=""/>
      </div>
      <div class="form_class">
        <Form
            validate-first
            label-width="100"
            @submit="handleFormCommit"
            @failed="onFailed"
            scroll-to-error
            colon
            :disabled="$route.query.from == 'my' || echoShow"
        >
          <!-- 联系人1 -->
          <div class="certification">
            <div class="certificationTitle">
              {{ l.other_kinsfolk_contacts }}
            </div>
            <div class="certificationDesc">({{ l.other_contacts_msg }})</div>
            <LableBox class="formInfo" :label="l.other_relation">
              <Field
                  readonly
                  clickable
                  name="relationType1"
                  :value="formData.relationType1"
                  :placeholder="l.other_s_relation"
                  @click="realFocus('relationType1')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>

            <Popup round v-model="relationTypePopup1" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="name"
                  :columns="immediateFamilyTypeOptions"
                  :default-index="relationTypeDefaultIndex1"
                  @confirm="immediateFamilyTypeChange"
                  @cancel="relationTypePopup1 = false"
              />
            </Popup>
            <LableBox class="formInfo" :label="l.other_name">
              <Field
                  v-if="$store.state.user.isNested"
                  readonly
                  clickable
                  name="relationName1"
                  :value="formData.relationName1"
                  :placeholder="l.other_s_name"
                  @click="selectContact('relationName1')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
              <Field
                  v-else
                  v-model="formData.relationName1"
                  name="relationName1"
                  :placeholder="l.other_p_name"
                  @focus="realFocus('relationName1')"
                  maxlength="50"
                  :rules="[{ required: true }]"
              />
            </LableBox>
            <LableBox class="formInfo" :label="l.other_phone">
              <Field
                  type="number"
                  v-model="formData.relationPhone1"
                  name="relationPhone1"
                  maxlength="10"
                  :readonly="$store.state.user.isNested"
                  :placeholder="$store.state.user.isNested?'':l.other_p_phone"
                  @focus="realFocus('relationPhone1')"
                  :rules="[
                  { required: true },
                  { validator: phoneRul, message: l.other_phone_layout },
                ]"
              />
            </LableBox>
          </div>
          <!-- 联系人2 -->
          <div class="certification">
            <div class="certificationTitle">
              {{ l.other_rest_contacts }}
            </div>
            <div class="certificationDesc">({{ l.other_contacts_msg }})</div>
            <LableBox class="formInfo" :label="l.other_relation">
              <Field
                  readonly
                  clickable
                  name="relationType2"
                  :value="formData.relationType2"
                  :placeholder="l.other_s_relation"
                  @click="realFocus('relationType2')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>

            <Popup round v-model="relationTypePopup2" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="name"
                  :columns="otherContactsTypeOptions"
                  :default-index="relationTypeDefaultIndex2"
                  @confirm="otherContactsTypeChange"
                  @cancel="relationTypePopup2 = false"
              />
            </Popup>
            <LableBox class="formInfo" :label="l.other_name">
              <Field
                  v-if="$store.state.user.isNested"
                  readonly
                  clickable
                  name="relationName2"
                  :value="formData.relationName2"
                  :placeholder="l.other_s_name"
                  @click="selectContact('relationName2')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
              <Field
                  v-else
                  v-model="formData.relationName2"
                  name="relationName2"
                  :placeholder="l.other_p_rest_name"
                  @focus="realFocus('relationName2')"
                  maxlength="50"
                  :rules="[{ required: true }]"
              />
            </LableBox>
            <LableBox class="formInfo" :label="l.other_phone">
              <Field
                  type="number"
                  v-model="formData.relationPhone2"
                  name="relationPhone2"
                  maxlength="10"
                  :readonly="$store.state.user.isNested"
                  :placeholder="$store.state.user.isNested?'':l.other_p_phone"
                  @focus="realFocus('relationPhone2')"
                  :rules="[
                  { required: true },
                  { validator: phoneRul, message: l.other_phone_layout },
                ]"
              />
              <!-- { pattern: /^\d{9,10}$/, message: l.other_phone_layout } -->
            </LableBox>
          </div>
          <!-- 联系人3 -->
          <!-- <div class="certification">
          <div class="certificationTitle">
            {{ l.other_emergency_contact }} 3
          </div>
          <div class="certificationDesc">({{ l.other_contacts_msg }})</div>
          <LableBox class="formInfo" :label="l.other_relation">
            <Field
              readonly
              clickable
              name="relationType3"
              :value="formData.relationType3"
              :placeholder="l.other_s_relation"
              @click="realFocus('relationType3')"
              :rules="[{ required: true }]"
            
            >
              <template #right-icon v-if="!echoShow">
                <img
                  class="right_img"
                  src="@/assets/userInfo/right@2x.png"
                  alt=""
                />
              </template>
            </Field>
          </LableBox>
          <Popup round v-model="relationTypePopup3" position="bottom">
            <Picker
              :confirm-button-text="l.login_ok"
              :cancel-button-text="l.login_btn_cancel"
              show-toolbar
              value-key="name"
              :columns="otherContactsTypeOptions"
              :default-index="relationTypeDefaultIndex3"
              @confirm="otherContactsTypeChange2"
              @cancel="relationTypePopup3 = false"
            />
          </Popup>
          <LableBox class="formInfo" :label="l.other_name">
            <Field
              v-model="formData.relationName3"
              name="relationName3"
              :placeholder="l.other_p_rest_name"
              @focus="realFocus('relationName3')"
              maxlength="50"
              :rules="[{ required: true }]"
            />
          </LableBox>
          <LableBox class="formInfo" :label="l.other_phone">
            <Field
              type="number"
              v-model="formData.relationPhone3"
              name="relationPhone3"
              maxlength="10"
              :placeholder="l.other_p_phone"
              @focus="realFocus('relationPhone3')"
              :rules="[
                { required: true },
                { validator: phoneRul, message: l.other_phone_layout },
              ]"
            />
          </LableBox>
        </div> -->

          <div class="certification">
            <div class="certificationTitle">
              {{ l.other_bank_title }}
            </div>
            <div class="certificationDesc">({{ l.other_bank_msg }})</div>
            <LableBox class="formInfo" :label="l.other_name">
              <Field
                  readonly
                  v-model="formData.card_hold_name"
                  name="card_hold_name"
                  :placeholder="l.other_bank_realname"
              />
            </LableBox>
            <LableBox class="formInfo" :label="l.other_bank">
              <Field
                  readonly
                  name="bank_name"
                  :value="formData.bank_name"
                  :placeholder="l.other_s_bank"
                  @click="realFocus('bank_name')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>

            <Popup round v-model="bankCodePopup" position="bottom"
            >
              <Field
                  :placeholder="l.other_s_query_bank"
                  v-model="keyWord"
                  clearable
                  left-icon="search"
                  @input="handleSearchNations(keyWord)"
              />
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="text"
                  :columns="currBankCodeOptions"
                  :default-index="bankCodeDefaultIndex"
                  @confirm="bankCodeChange"
                  @cancel="bankCodePopup = false"
              >
                <template #option="text">
                  <div class="option_item">
                    {{ text.text }}
                  </div>
                </template>
              </Picker>
            </Popup>

            <LableBox class="formInfo" :label="l.other_bank_code">
              <Field
                  readonly
                  name="bank_code"
                  :value="formData.bank_code"
                  :placeholder="l.other_s_bank_code"
                  @click="realFocus('bank_code')"
                  :rules="[{ required: true }]"
              >
              </Field>
            </LableBox>
            <!-- <LableBox class="formInfo" :label="l.other_bank_type">
              <Field
                readonly
                name="card_type"
                :value="formData.card_type"
                :placeholder="l.other_s_bank_account_type"
              disabled
                @click="realFocus('card_type')"
                :rules="[{ required: true }]"
              >
              </Field>
            </LableBox> -->
<!--            <Popup round v-model="cardTypePopup" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  value-key="text"
                  @confirm="cardTypeChange"
                  @cancel="cardTypePopup = false"
                  show-toolbar
                  :columns="cardTypeOptions"
              />
            </Popup>-->

            <LableBox class="formInfo" :label="l.other_bank_branches">
              <Field
                  v-model="formData.branchName"
                  name="branchName"
                  :placeholder="l.other_p_bank_branches"
                  @focus="realFocus('branchName')"
                  :rules="[
                  {
                    required: true,
                  },
                ]"
              />
            </LableBox>

            <LableBox class="formInfo" :label="l.other_band_account">
              <Field
                  v-model="formData.card_no"
                  type="number"
                  name="card_no"
                  :placeholder="l.other_p_band_account"
                  @focus="realFocus('card_no')"
                  :rules="[
                  {
                    required: true,
                  },
                ]"
              />
            </LableBox>
          </div>

          <!-- 下一步 -->
          <div>
            <Button
                class="nextStep"
                v-if="$route.query.from != 'my' && !echoShow"
                block
                type="info"
                @click="commitPopup = true"
                native-type="submit"
            >{{ l.other_commit }}
            </Button
            >
          </div>
        </Form>
      </div>
    </div>
    <div class="face_post" v-if="showFacePost">
      <!-- <template v-if="!base64Img"> -->
      <video
          id="videoSteal"
          width="288"
          height="220"
          playsinline
          webkit-playsinline="true"
          preload
          autoplay
          loop
          muted
      ></video>
      <!-- <canvas id="canvas" width="2048" height="2048"></canvas> -->
      <canvas id="screenshotCanvasSteal" width="288" height="220"></canvas>
      <!-- </template> -->
    </div>
  </div>
</template>

<script>
import {
  Icon,
  // Progress,
  Form,
  Field,
  Button,
  Popup,
  Picker,
  Toast,
} from "vant";
// import SelectCpt from "../../components/select-cpt";
import {
  queryUserContact,
  userContact,
  queryUserBase,
  userDict,
} from "../../services/information";
import {getBankList} from "../../services/order";
import {userStatus} from "@/services/home";
import l from "../../locales";
import {lrzUploadImage} from "../../services/upload";
import LableBox from "../../components/lable-box";
// import { checkPhone } from "@/utils/index";
export default {
  name: "other",
  components: {
    Icon,
    // Progress,
    Form,
    Field,
    Button,
    // SelectCpt,
    Popup,
    Picker,
    LableBox,
  },
  data() {
    return {
      showFacePost: true,
      l: {...l.other, ...l.login},
      echoShow: false,
      formData: {
        card_hold_name: undefined,
        relationType1: undefined, //number 直系亲属 1-父亲 2-母亲 3-配偶 4-儿子 5-女儿 6-兄弟 7-姐妹
        relationName1: undefined, //string 直系亲属名
        relationPhone1: undefined, //string 直系亲属手机号
        relationType2: undefined, //number 其他联系人 1-同学 2-亲戚 3-同事 4-朋友 5-其他
        relationName2: undefined, //string 其他联系人姓名
        relationPhone2: undefined, //string 其他联系人手机号
        // relationType3: null, //number 其他联系人 1-同学 2-亲戚 3-同事 4-朋友 5-其他
        // relationName3: null, //string 其他联系人姓名
        // relationPhone3: null, //string 其他联系人手机号
        card_type: "0", //number 银行账户类型 0-账号 1-卡号
        bankName: undefined, //string 银行名
        card_no: undefined, //string 银行卡账号/卡号
        bank_code: undefined, //string 银行编号
        branchName: undefined, //string 银行分行
      },

      immediateFamilyTypeOptions: [],
      otherContactsTypeOptions: [],
      bankCodeOptions: [],
      relationTypePopup1: false,
      relationTypeDefaultIndex1: 0,
      relationTypePopup2: false,
      relationTypeDefaultIndex2: 0,
      relationTypePopup3: false,
      relationTypeDefaultIndex3: 0,
      bankCodePopup: false,
      bankCodeDefaultIndex: 0,
      cardTypePopup: false,
      cardTypeDefaultIndex: 0,

      videoSteal: null,
      screenshotCanvasSteal: null,
      uploadLockSteal: true, // 上传锁
      base64ImgSteal: null,
      trackerTaskSteal: null,
      keyWord: "",
      currBankCodeOptions: [],
      cardTypeOptions: [],
    };
  },
  methods: {
    selectContact(name) {
      console.log("selectContact", name)
      let index = -1;
      if (name == "relationName1") {
        index = "1";
      } else if (name == "relationName2") {
        index = "2";
      }
      if (index != -1) {
        console.log("调用selectContact", index)
        window.getSelectContact = this.getSelectContact;
        this.$tools.androidMethod("selectContact", {
          index
        }, "getSelectContact");
      }
    },
    getSelectContact(data) {
      console.log("getSelectContact", data)
      let {
        index,
        name,
        phone
      } = data.data;
      phone = phone.replaceAll(" ", "");
      // if (this.phoneRule()) {
      //   Toast(this.l.other_two_s_phone_msg);
      //   return;
      // }
      this.$set(this.formData, "relationPhone" + index, phone);
      this.$set(this.formData, "relationName" + index, name);
    },
    handleSearchNations(keyWord) {
      console.log("keyWord", keyWord);
      this.currBankCodeOptions = this.bankCodeOptions.filter((v) => {
        return v.text.toLowerCase().includes(keyWord.toLowerCase());
      });
    },
    realFocus(str) {
      if (this.$route.query.from == "my" || this.echoShow) {
        return;
      }
      if (str == "relationType1") {
        this.relationTypePopup1 = true;
      } else if (str == "relationType2") {
        this.relationTypePopup2 = true;
      } else if (str == "relationType3") {
        this.relationTypePopup3 = true;
      } else if (str == "bank_name") {
        this.bankCodePopup = true;
      }
      //  else if (str == "card_type") {
      //   this.cardTypePopup = true;
      // }
    },
    phoneRul(value) {
      if (this.$store.state.user.isNested) {
        return true;
      }
      if (value.length == 10 && value[0] == 0 && value[1] == 9) {
        // len = false;
        return true;
      }
      if (value.length == 9 && value[0] == 9) {
        return true;
      }
      return false;
    },
    phoneRule() {
      if (this.formData.relationPhone1 !== this.formData.relationPhone2) {
        return false;
      } else {
        return true;
      }
    },
    // 与本人关系 relationType1
    immediateFamilyTypeChange(value) {
      this.formData.relationType1 = value.name;
      this.relationTypePopup1 = false;
    },
    // 与本人关系 relationType2
    otherContactsTypeChange(value) {
      this.formData.relationType2 = value.name;
      this.relationTypePopup2 = false;
    },
    // 与本人关系 relationType2
    otherContactsTypeChange2(value) {
      this.formData.relationType3 = value.name;
      this.relationTypePopup3 = false;
    },
    // 银行类型
    cardTypeChange(value) {
      this.formData.card_type = value.text;
      this.cardTypePopup = false;
    },
    // 银行选择
    bankCodeChange(value) {
      // this.formData.bank_code = value;
      this.formData.bank_name = value.text;
      this.formData.bank_code = value.value;
      this.bankCodePopup = false;

      // 过滤相应的银行***
      let bankObj = this.bankCodeOptions.filter(
          (item) => item.value === value.value
      )[0];
      this.formData.bankName = bankObj.text;
    },
    handlenNavBarBack() {
      this.$router.back(1);
    },
    // 初始化设置
    async initTrackingSteal() {
      let _this = this;
      _this.$nextTick(() => {
        _this.videoSteal = document.getElementById("videoSteal");
        _this.screenshotCanvasSteal = document.getElementById(
            "screenshotCanvasSteal"
        );

        // let canvas = document.getElementById("canvas");
        // let context = canvas.getContext("2d");

        // 固定写法
        let tracker = new window.tracking.ObjectTracker("face");
        tracker.setInitialScale(4);
        tracker.setStepSize(2);
        tracker.setEdgesDensity(0.1);
        _this.trackerTaskSteal = window.tracking.track("#videoSteal", tracker, {
          camera: true,
        });

        tracker.on("track", function (event) {
          // 检测出人脸 绘画人脸位置
          // context.clearRect(0, 0, canvas.width, canvas.height);
          // event.data.forEach(function (rect) {
          event.data.forEach(function () {
            // context.strokeStyle = "#0764B7";
            // context.strokeRect(rect.x, rect.y, rect.width, rect.height);
            console.log("已识别到人脸");

            // 上传图片
            _this.uploadLockSteal && _this.screenshotAndUploadSteal();
            tracker = null;
          });
        });
        console.log("initTracking");
      });
    },
    // 上传图片
    screenshotAndUploadSteal() {
      let that = this;
      // 上锁避免重复发送请求
      this.uploadLockSteal = false;

      // 绘制当前帧图片转换为base64格式
      let canvas = this.screenshotCanvasSteal;
      let video = this.videoSteal;
      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      let base64Img = canvas.toDataURL("image/jpeg");

      // 使用 base64Img 请求接口即可
      // console.log('base64Img:', base64Img);
      this.base64ImgSteal = base64Img;
      //调用
      var file = this.base64toFile(base64Img);

      lrzUploadImage(file, "facePhoto4", () => {
        that.trackerTaskSteal && that.trackerTaskSteal.stop();
      });
      console.log("file", file);
      // 请求接口成功以后打开锁
    },
    base64toFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },
    // 表单发提交
    handleFormCommit(e) {
      if (this.phoneRule()) {
        Toast(this.l.other_two_phone_msg);
        return;
      }

      let params = {...e};
      params.bankName = this.formData.bankName;

      params.relationType1 = this.immediateFamilyTypeOptions.filter(
          (item) => item.name === params.relationType1
      )[0].id;
      params.relationType2 = this.otherContactsTypeOptions.filter(
          (item) => item.name === params.relationType2
      )[0].id;
      // params.relationType3 = this.otherContactsTypeOptions.filter(
      //   (item) => item.name === params.relationType3
      // )[0].id;
      params.bank_code = this.bankCodeOptions.filter(
          (item) => item.text == params.bankName
      )[0].value;

      // params.bank_code = "004";

      params.card_type = "1";
      // params.card_type = this.cardTypeOptions.filter(
      //   (item) => item.text == params.card_type
      // )[0].value;

      // 将联系人合成为一个数组
      let relationList = [
        {
          relationType: params.relationType1,
          relationName: params.relationName1,
          relationPhone: params.relationPhone1,
        },
        {
          relationType: params.relationType2,
          relationName: params.relationName2,
          relationPhone: params.relationPhone2,
        },
        // {
        //   relationType: params.relationType3,
        //   relationName: params.relationName3,
        //   relationPhone: params.relationPhone3,
        // },
      ];
      params.relationList = relationList;

      delete params.relationType1;
      delete params.relationName1;
      delete params.relationPhone1;
      delete params.relationType2;
      delete params.relationName2;
      delete params.relationPhone2;
      // delete params.relationType3;
      // delete params.relationName3;
      // delete params.relationPhone3;
      delete params.bankName;

      userContact(params).then((res) => {
        // console.log("-------------res=",res);
        if (res.code == 200) {
          this.$saveAppsFlyer("其他信息提交");
          localStorage.setItem("vic_mall", "true");
          // console.log(this.$route.query);
          let h5AuthURL = this.$store.state.user.userInfo.vayHubAuthUrl;
          // Toast(h5AuthURL);
          let pathUrl = this.VIC_URL(
              h5AuthURL,
              localStorage.getItem("channel")
          );
          sessionStorage.setItem("pathUrl", pathUrl);
          setTimeout(() => {
            window.location.href = pathUrl;
          }, 100);
          // }, 2000);
        }
      });
    },
    // VIC_URL(h5AuthURL) {
    VIC_URL() {
      let currUrl = `${location.protocol}//${window.location.host}/home?vayHub=1`;
      // let callBack = `${h5AuthURL}&callBack=${currUrl}`
      // if (process.env.VUE_APP_GENRE === "nested" && this.$store.state.user.userInfo.pkg_name == "com.offline.vay24") {
      //   callBack = currUrl;
      // }

      // console.log(callBack,encodeURIComponent(callBack));
      // return `${h5AuthURL}&callBack=${callBack}`;
      // return callBack;
      return currUrl;
    },
    // 表单验证提交
    onFailed(err) {
      console.log(err);
    },
    async getBankList() {
      let bankList = await getBankList({pay_type: "1"});
      if (bankList.code == 200) {
        this.bankCodeOptions = bankList.result.map((item) => {
          return {
            // text: item.bank_name + "(" + item.bank_alias + ")",
            text: item.bank_name,
            value: item.bank_code,
          };
        });
        this.currBankCodeOptions = JSON.parse(
            JSON.stringify(this.bankCodeOptions)
        );
      }
    },
    async getUserContact() {
      let userContact = await queryUserContact();
      if (userContact.code == 200) {
        userContact.result && (this.formData = {...userContact.result});

        let formData = this.formData;
        if (formData.card_type === null) {
          formData.card_type = "0";
        }
        // relationType1: null, //number 直系亲属 1-父亲 2-母亲 3-配偶 4-儿子 5-女儿 6-兄弟 7-姐妹
        // relationName1: null, //string 直系亲属名
        // relationPhone1: null, //string 直系亲属手机号
        // relationType2: null, //number 其他联系人 1-同学 2-亲戚 3-同事 4-朋友 5-其他
        // relationName2: null, //string 其他联系人姓名
        // relationPhone2: null, //string 其他联系人手机号
        if (formData.relationList && formData.relationList.length != 0) {
          const relation1 = formData.relationList[0];
          const relation2 = formData.relationList[1];
          // const relation3 = formData.relationList[2];
          if (relation1) {
            formData.relationType1 = relation1.relationType;
            formData.relationName1 = relation1.relationName;
            formData.relationPhone1 = relation1.relationPhone;
          }
          if (relation2) {
            formData.relationType2 = relation2.relationType;
            formData.relationName2 = relation2.relationName;
            formData.relationPhone2 = relation2.relationPhone;
          }
          // if (relation3) {
          //   formData.relationType3 = relation3.relationType;
          //   formData.relationName3 = relation3.relationName;
          //   formData.relationPhone3 = relation3.relationPhone;
          // }
        }
        if (formData.relationType1 || formData.relationType1 == 0) {
          const immediateFamilyTypefilArr = this.immediateFamilyTypeOptions.filter(
              (item) => item.id == formData.relationType1
          )[0];
          formData.relationType1 = immediateFamilyTypefilArr.name;
          this.relationTypeDefaultIndex1 = this.immediateFamilyTypeOptions.indexOf(
              immediateFamilyTypefilArr
          );
        }

        if (formData.relationType2 || formData.relationType2 == 0) {
          const otherContactsTypefilArr = this.otherContactsTypeOptions.filter(
              (item) => item.id == formData.relationType2
          )[0];
          formData.relationType2 = otherContactsTypefilArr.name;
          this.relationTypeDefaultIndex2 = this.otherContactsTypeOptions.indexOf(
              otherContactsTypefilArr
          );
        }

        // if (formData.relationType3 || formData.relationType3 == 0) {
        //   const otherContactsTypefilArr = this.otherContactsTypeOptions.filter(
        //     (item) => item.id == formData.relationType3
        //   )[0];
        //   formData.relationType3 = otherContactsTypefilArr.name;
        //   this.relationTypeDefaultIndex3 = this.otherContactsTypeOptions.indexOf(
        //     otherContactsTypefilArr
        //   );
        // }
        if (formData.card_type || formData.card_type == 0) {
          const cardTypefilArr = this.cardTypeOptions.filter(
              (item) => item.value == formData.card_type
          )[0];
          formData.card_type = cardTypefilArr.text;
          this.cardTypeDefaultIndex = this.cardTypeOptions.indexOf(
              cardTypefilArr
          );
        }
        // 银行
        console.log(formData.bank_code,formData.bank_code == 0,formData.bank_code == "")

        console.log("formData.bank_code || formData.bank_code == 0",formData.bank_code || formData.bank_code == 0,formData.bank_code , formData.bank_code == 0)
        if (formData.bank_code || formData.bank_code == 0) {
          const bankCodefilArr = this.bankCodeOptions.filter(
              (item) => item.value == formData.bank_code
          )[0];
          console.log(formData.bank_code, bankCodefilArr);
          if(bankCodefilArr && bankCodefilArr.text){
            formData.bank_code = bankCodefilArr.value;
            formData.bankName = bankCodefilArr.text;
            formData.bank_name = bankCodefilArr.text;
          }
          this.bankCodeDefaultIndex = this.bankCodeOptions.indexOf(
              bankCodefilArr
          );
        }
        this.formData = {...formData};
        console.log("this.formData", this.formData);
        this.getUserBase();
      }
    },
    async getUserBase() {
      let userBase = await queryUserBase();
      if (userBase.code == 200) {
        this.formData.card_hold_name = userBase.result.real_name;
      }
    },
    async getDict() {
      let dict = await userDict();
      if (dict.code == 200) {
        console.log("dict", dict.result);
        let { FamilyRelation, FamilyRelation2 } = dict.result;
        this.immediateFamilyTypeOptions = FamilyRelation;
        this.otherContactsTypeOptions = FamilyRelation2;
        console.log("this.genderOptions2", this.genderOptions);
      }
    },
    async init() {
      await Promise.all([this.getDict(), this.getBankList()])
      this.getUserContact();
    },
  },
  destroyed() {
    // 关闭摄像头和侦测
    this.showFacePost = false;
    this.trackerTaskSteal && this.trackerTaskSteal.stop();
    this.trackerTaskSteal = null;
  },
  created() {
    if (localStorage.getItem("isReloan") && localStorage.getItem("isReloan") == 1) {
      localStorage.removeItem("isReloan")
      location.reload();
    }

    this.init();
    // this.initTrackingSteal();
    this.$saveAppsFlyer("进入其他信息");

    this.cardTypeOptions = [
      {text: this.l.other_account, value: "0"},
      {text: this.l.other_card_num, value: "1"},
    ];

    userStatus().then((res) => {
      // console.log("userStatus", res);
      if (res.result.loan_status != "1") {
        this.echoShow = true;
      }
    });
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";

.other {
  padding-bottom: 50px;
  width: 100%;
  height: 100%;
  //background: url("../../assets/my/bgc.png") no-repeat #fff;
  //background-size: 100%;
  background: #F5F5F5;
}

.face_post {
  position: absolute;
  z-index: -10000;
  top: 0;
  // left: -5000px;
  opacity: 0;
}

/deep/ .van-overlay {
  background: rgba(101, 101, 101, 0.2);
  backdrop-filter: blur(3px);
}

.form_body {
  /deep/ .van-picker__confirm {
    color: #EF9614;
  }

  //.certification {
  //  margin: 0 20px;
  //  margin-top: 12px;
  //  padding: 10px 0;
  //  padding-top: 20px;
  //  box-sizing: border-box;
  //  width: calc(100% - 40px);
  //
  //  background: linear-gradient(to left,
  //  transparent 0%,
  //  transparent 50%,
  //  rgba(0, 177, 12, 0.2) 50%,
  //  rgba(0, 177, 12, 0.2) 100%);
  //  background-size: 12px 1px;
  //  background-repeat: repeat-x;
  //
  //  .certificationTitle {
  //    margin-bottom: 10px;
  //
  //    font-size: 16px;
  //    font-family: PingFangSC-Medium, PingFang SC;
  //    font-weight: 500;
  //    color: #324353;
  //  }
  //
  //  .certificationDesc {
  //    margin-top: 4px;
  //
  //    margin-bottom: 10px;
  //
  //    font-size: 11px;
  //    font-family: PingFangSC-Regular, PingFang SC;
  //    font-weight: 400;
  //    color: #6c6d6f;
  //  }
  //
  //  .formInfo {
  //    padding-top: 0;
  //
  //    /deep/ .lable_title {
  //      padding-left: 0;
  //
  //      font-size: 14px;
  //      font-family: PingFangSC-Regular, PingFang SC;
  //      font-weight: 400;
  //      color: #6c6d6f;
  //    }
  //
  //    /deep/ .van-cell {
  //      font-size: 14px;
  //      font-family: PingFangSC-Regular, PingFang SC;
  //      font-weight: 400;
  //      color: #232425;
  //    }
  //  }
  //
  //  &:first-child {
  //    padding-top: 0;
  //    background: none;
  //  }
  //}
}

/deep/ .van-popup {
  .van-field__value {
    display: flex;
    align-items: center;
  }
}

.option_item {
  font-size: 12px;
  text-align: center;
  line-height: 18px;
}
</style>
